import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
/**
 * Builder for creating the column config for the editable table.
 * Contains the following flags
 * 1. {String} id: Column ID to uniquely identify a column. It is a mandatory field and should always be provided.
 * 2. {String / Function} accessor: This can be both a function and a method which basically returns the value which needs to be displayed in the field.
 * 3. {Number} width: Initial width of the column.
 * 4. {String} Header: Title of the column.
 * 5. {Function} mapCellPropsToComponentProps: This basically is used to convert the props provided to the cell to provide conditional props to the rendered component in the cell.
 *    One of the usecase for the above would be to provide conditonal classes to the cell.
 * 6. {Array} cellConfig: An array of configs which need to be displayed the a certain column.
 *    If the column only contains a single cell then its an array of a single config without shouldRender set.
 *    If a column can have multiple renderers, then its an array of configs with a shouldRender function.
 */

// Constants
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import _noop from 'lodash/noop';
var ColumnConfig = /*#__PURE__*/function () {
  function ColumnConfig(columnId) {
    _classCallCheck(this, ColumnConfig);
    this.id = columnId;
    this.cellConfig = [];
    this.sortable = false;
    this.isConfigurable = true;
  }
  _createClass(ColumnConfig, [{
    key: "setAccessor",
    value: function setAccessor(accessor) {
      this.accessor = accessor;
      return this;
    }
  }, {
    key: "setPivotAccessor",
    value: function setPivotAccessor(pivotAccessor) {
      this.pivotAccessor = pivotAccessor;
      return this;
    }
  }, {
    key: "setPivotCell",
    value: function setPivotCell(PivotCell) {
      this.PivotCell = PivotCell;
      return this;
    }
  }, {
    key: "setFixed",
    value: function setFixed(direction) {
      this.fixed = direction;
      return this;
    }
  }, {
    key: "setSortMethod",
    value: function setSortMethod() {
      var sortMethod = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _noop;
      this.sortMethod = sortMethod;
      return this;
    }
  }, {
    key: "setWidth",
    value: function setWidth(width) {
      this.width = width;
      return this;
    }
  }, {
    key: "setSortable",
    value: function setSortable(sortable) {
      this.sortable = sortable;
      return this;
    }
  }, {
    key: "addCellConfig",
    value: function addCellConfig() {
      var cellConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
      this.cellConfig.push(cellConfig);
      return this;
    }
  }, {
    key: "setMapCellPropsToComponentProps",
    value: function setMapCellPropsToComponentProps(mapCellPropsToComponentProps) {
      this.mapCellPropsToComponentProps = mapCellPropsToComponentProps;
      return this;
    }
  }, {
    key: "setTitle",
    value: function setTitle() {
      var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.Header = title;
      return this;
    }
  }, {
    key: "setHeader",
    value: function setHeader(header) {
      this.Header = header;
      return this;
    }
  }, {
    key: "setGetValueFromOnChange",
    value: function setGetValueFromOnChange() {
      var getValueFromOnChange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _noop;
      this.getValueFromOnChange = getValueFromOnChange;
      return this;
    }
  }, {
    key: "setHeaderClassName",
    value: function setHeaderClassName() {
      var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.headerClassName = className;
      return this;
    }
  }, {
    key: "setClassName",
    value: function setClassName() {
      var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.className = className;
      return this;
    }
  }, {
    key: "setFooter",
    value: function setFooter(footer) {
      this.Footer = footer;
      return this;
    }
  }, {
    key: "setMinWidth",
    value: function setMinWidth(minWidth) {
      this.minWidth = minWidth;
      return this;
    }
  }, {
    key: "getColumnId",
    value: function getColumnId() {
      return this.id;
    }
  }, {
    key: "setKey",
    value: function setKey(key) {
      this.key = key;
      return this;
    }
  }, {
    key: "setIsConfigurable",
    value: function setIsConfigurable(isConfigurableField) {
      this.isConfigurable = isConfigurableField;
      return this;
    }
  }, {
    key: "setResizable",
    value: function setResizable() {
      var isResizable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.resizable = isResizable;
      return this;
    }
  }]);
  return ColumnConfig;
}();
export default ColumnConfig;